// @needs-native-review — best-effort translation
import type { ChromeTranslations } from '../types';

export const it: ChromeTranslations = {
  'nav.nextPage': 'pagina successiva →',
  'nav.previousPage': '← pagina precedente',
  'nav.continueToLevel': 'continua al livello →',
  'nav.backToMenu': 'torna al menu →',
  'howto.page': 'pagina {n} di {total}',
  'options.title': 'Opzioni',
  'ui.language': 'Lingua',
};
